export default "__VITE_ASSET__1749fc5a__"